<template>
    <SvgIcon v-bind="props">
        <template #default>
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M8.8418 5.9375V11.9476"
                    stroke="var(--joy-color-neutral-60)"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M5.75195 8.94141H11.9338"
                    stroke="var(--joy-color-neutral-60)"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17Z"
                    stroke="var(--joy-color-neutral-60)"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </template>
    </SvgIcon>
</template>

<script lang="ts" setup>
    import SvgIcon from '@navbar-common/ui/SvgIcon.vue';
    import type {CommonIconProps} from '@navbar-logged/common/icons/common-props';

    const props = withDefaults(defineProps<CommonIconProps>(), {
        svgSize: 18,
        svgColor: 'var(--joy-color-neutral-60)',
    });
</script>
